import { allResources, allRoles } from '../constants/setupAuth';

export const getDevScopes = () => {
  const devScopes = window.config.auth.devScopes.toLowerCase();
  switch (devScopes) {
    case 'all':
      return allResources.map(resource => resource.name);
    case 'none':
      return [];
    default:
      return allRoles.find(role => role.name.toLowerCase() === devScopes).resources;
  }
}

export const capitalizeFirstLetter = (string) =>
  string.charAt(0).toUpperCase() + string.slice(1);

export const extractNamesFromEmail = (email) => {
  const fullName = email.slice(0, email.indexOf('@'));
  const dotIndex = fullName.indexOf('.');
  const firstName = dotIndex > -1 ? capitalizeFirstLetter(fullName.slice(0, dotIndex)) : 'Tic';
  const lastName = dotIndex > -1 ? capitalizeFirstLetter(fullName.slice(dotIndex + 1)) : 'Tac';
  const initials = `${firstName.charAt(0)}${lastName.charAt(0)}`.toUpperCase();
  return [ firstName, lastName, initials];
}

export const createDevUser = () => {
  const email = window.config.auth.email || 'tictacteam@ssense.com';
  const [ firstName, lastName, initials ] = extractNamesFromEmail(email);
  return {
    firstName,
    lastName,
    email,
    picture: `https://via.placeholder.com/300x300/000000/FFFFFF/?text=${initials.toUpperCase()}`,
    scopes: getDevScopes()
  }
}
